const RateShopTypes = {
  GET_CARRIERS_BY_CUSTOMER_PROGRESS: 'RateShop_TYPES.GET_CARRIERS_BY_CUSTOMER_PROGRESS',
  GET_CARRIERS_BY_CUSTOMER_SUCCESS: 'RateShop_TYPES.GET_CARRIERS_BY_CUSTOMER_SUCCESS',
  GET_CARRIERS_BY_CUSTOMER_ERROR: 'RateShop_TYPES.GET_CARRIERS_BY_CUSTOMER_ERROR',

  GET_ACCESSORIALS_LIST_PROGRESS: 'RateShop_TYPES.GET_ACCESSORIALS_LIST_PROGRESS',
  GET_ACCESSORIALS_LIST_SUCCESS: 'RateShop_TYPES.GET_ACCESSORIALS_LIST_SUCCESS',
  GET_ACCESSORIALS_LIST_ERROR: 'RateShop_TYPES.GET_ACCESSORIALS_LIST_ERROR',

  GET_TAX_LIST_PROGRESS: 'RateShop_TYPES.GET_TAX_LIST_PROGRESS',
  GET_TAX_LIST_SUCCESS: 'RateShop_TYPES.GET_TAX_LIST_SUCCESS',
  GET_TAX_LIST_ERROR: 'RateShop_TYPES.GET_TAX_LIST_ERROR',

  SET_GLOBAL_RATE_SHOP_TAB: 'RateShop_TYPES.SET_GLOBAL_RATE_SHOP_TAB',
  SET_RATE_SHOP_LANE_TAB: 'RateShop_TYPES.SET_RATE_SHOP_LANE_TAB',
  SET_RATE_SHOP_LANE_STOP_TAB: 'RateShop_TYPES.SET_RATE_SHOP_LANE_STOP_TAB',
  SET_RATE_SHOP_STOPS_DRAWER: 'RateShop_TYPES.SET_RATE_SHOP_STOPS_DRAWER',
  SET_GLOBAL_RATE_SHOP_MEASUREMENT_UNIT: 'RateShop_TYPES.SET_GLOBAL_RATE_SHOP_MEASUREMENT_UNIT',

  GET_RATE_RESULTS_PROGRESS: 'RateShop_TYPES.GET_RATE_RESULTS_PROGRESS',
  GET_RATE_RESULTS_SUCCESS: 'RateShop_TYPES.GET_RATE_RESULTS_SUCCESS',
  GET_RATE_RESULTS_ERROR: 'RateShop_TYPES.GET_RATE_RESULTS_ERROR',

  SET_SELECTED_CARRIER_RATE: 'RateShop_TYPES.SET_SELECTED_CARRIER_RATE',
  SET_SELECTED_CARGO_TYPES: 'RateShop_TYPES.SET_SELECTED_CARGO_TYPES',
  SET_ITEMS_SUM_VALUES: 'RateShop_TYPES.SET_ITEMS_SUM_VALUES',
};

export default RateShopTypes;
